import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import ForgotPasswordDialog from "@/views/modals/forgot-password";
import eyesClosed from "@/assets/icons/eyes-closed.svg";
import PasswordInput from "../../components/Form/PasswordInput.vue";


export default {
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.status,
      list: (state) => state.Menu.list,
    }),
    canSubmit() {
      // Retorna true si ambos campos tienen texto
      return this.user.email.trim() !== '' && this.user.password.trim() !== '';
    }
  },
  data: () => ({
    showForgotPassword: false,
    validation_message: "",
    valid: false,
    user: {
      email: "",
      password: "",
    },
    eyesClosed,
    show1: "",
  }),
  methods: {
    async login() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      self.setValidationMessage("");
      if (valid) {
        self.$store
            .dispatch("Authenticate/login", self.user)
            .then((value) => {
              if (value.role === "admin") {
                self.$router.push("/admin/dashboard");
              } else if (value.access_menus.length > 0) {
                // Tomar el primer link permitido (hijo)
                const firstLink = value.access_menus[0];

                if (firstLink) {
                  self.$router.push(firstLink).catch(() => {});
                }
              }
            })
            .catch(() => {
              self.setValidationMessage("El correo o contraseña son incorrectos.");
            });
      }
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    hideForgotPassword() {
      this.showForgotPassword = false;
    },
    removeReadonly(event) {
      event.target.removeAttribute("readonly");
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ForgotPasswordDialog,
    PasswordInput
  },
};
